<template>
  <div class="graduate-panel">
    <div class="panel-title">{{ titleName }}</div>
    <div class="graduate-top-cards">
      <div class="graduate-card">
        <div class="graduate-card-content">
          <img src="../assets/images/hom_year.png" alt="icon_graduate_1" class="graduate-card-icon">
          <div>
            <div class="graduate-card-title">{{ graduateData.configName }}</div>
            <div class="graduate-card-value">{{ graduateData.configValue }}<span style="font-size: 13px;">人(参保2671人)</span><span
                class="graduate-card-rate up">{{ graduateData.remark }}</span></div>
          </div>
        </div>
      </div>
      <div class="graduate-card">
        <div class="graduate-card-content">
          <img src="../assets/images/hom_year.png" alt="icon_graduate_1" class="graduate-card-icon">
          <div>
            <div class="graduate-card-title">{{ graduateDataAdd.configName }}</div>
            <div class="graduate-card-value">{{ graduateDataAdd.configValue }}<span
                style="font-size: 13px;">人</span><span
                class="graduate-card-rate up">{{ graduateDataAdd.remark }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-title">
      <img src="@/assets/images/title_line.png" alt="年龄"/>
      学历层次
    </div>
    <div class="graduate-edu-cards">
      <div class="edu-card" v-for="item in eduList" :key="item.name" :style="{ backgroundImage: item.bg }">
        <div class="edu-card-value" :style="{ color: item.color }">{{ item.value }}<span
            style="font-size: 13px;">人</span></div>
        <div class="edu-card-label" :style="{ color: item.color }">{{ item.name }}</div>
      </div>
    </div>
    <div class="graduate-bar-title">
      <div style="width: 50%;">
        <img src="@/assets/images/title_line.png" alt="年龄"/> 生源地
      </div>

      <div style="width: 50%;margin-left: 15px;color: #282828;font-size: 14px;">
        <img src="@/assets/images/title_line.png" alt="年龄"/> <span>毕业院校</span>
        <span class="more-schools" @click="showAllSchools">更多院校></span>
      </div>

    </div>
    <div class="graduate-school-list-container-box">
      <div class="graduate-school-list-container">
        <div class="graduate-school-list">
          <div class="graduate-school-item" v-for="item in displaySourceList" :key="item.name">
            <span class="school-label">{{ item.name }}</span>
            <div class="school-bar-row">
              <div class="school-bar-bg">
                <div class="school-bar-fg"
                     :style="{ width: (item.value / maxSoure * 100) + '%', background: item.color }">
                </div>
              </div>
              <div class="school-value">{{ item.value }}人</div>
            </div>
          </div>
        </div>
      </div>
      <div class="graduate-school-list-container">
        <div class="graduate-school-list" ref="schoolListContainer">
          <div class="graduate-school-item" v-for="item in schoolList" :key="item.name">
            <div class="school-label">{{ item.name }}</div>
            <div class="school-bar-row">
              <div class="school-bar-bg">
                <div class="school-bar-fg"
                     :style="{ width: (item.value / maxSchool * 100) + '%', background: item.color }">
                </div>
              </div>
              <div class="school-value">{{ item.value }}人</div>
            </div>
          </div>
          <!-- 复制一份数据用于无缝循环 -->
          <div class="graduate-school-item" v-for="item in schoolList" :key="'copy-' + item.name">
            <div class="school-label">{{ item.name }}</div>
            <div class="school-bar-row">
              <div class="school-bar-bg">
                <div class="school-bar-fg"
                     :style="{ width: (item.value / maxSchool * 100) + '%', background: item.color }">
                </div>
              </div>
              <div class="school-value">{{ item.value }}人</div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="chart-title2">
      <div style="color: #282828;">
        <img src="@/assets/images/title_line.png" alt="年龄"/>
        重点产业分布
      </div>
      <span class="chart-title-unit" style="margin-right: 20px;"></span>
    </div>
    <div ref="industryChart" class="industry-chart"></div>

    <!-- 与 GraduatePanel2 一致：挂 body + 70vh，避免 autofit transform 下 fixed/vh 错位 -->
    <Teleport to="body">
      <div v-if="isModalVisible" class="school-modal" @click.self="closeModal">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>更多院校</h3>
            <span class="close-btn" @click="closeModal">&times;</span>
          </div>
          <div class="modal-body">
            <div class="school-list">
              <div class="school-item" v-for="item in schoolList" :key="item.name">
                <div class="school-label">{{ item.name }}</div>
                <div class="school-bar-row">
                  <div class="school-bar-bg">
                    <div class="school-bar-fg"
                         :style="{ width: (item.value / maxSchool * 100) + '%', background: item.color }">
                    </div>
                  </div>
                  <div class="school-value">{{ item.value }}人</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import benke from '../assets/images/home_ben.png'
import shuoshi from '../assets/images/home_shuo.png'
import zhuanke from '../assets/images/edu_zhuan.png'
import boshi from '../assets/images/boshi.png'

export default {
  name: 'GraduatePanel',
  props: {
    dataObject: {
      type: Object,
      required: true
    }
  },
  watch: {
    dataObject: {
      handler(newVal) {
        console.log('树木 已更新:', JSON.stringify(newVal))
        if (newVal && Object.keys(newVal).length > 0) {
          // 数据已更新，可以在这里更新图表
          this.$nextTick(() => {
            this.updateCharts()
          })
          // this.refreshTimer2 = setInterval(() => {
          //   this.initIndustryChart();
          // }, 6000);
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      titleName: '',
      graduateData: {},
      graduateDataAdd: {},
      eduList: [
        {name: '专科', value: '59,5100', color: '#4d8aff', bg: `url(${zhuanke})`},
        {name: '本科', value: '86,5200', color: '#ff914d', bg: `url(${benke})`},
        {name: '硕士研究生', value: '67,5140', color: '#3edfa7', bg: `url(${shuoshi})`},
        {name: '博士研究生', value: '67,5140', color: '#3edfa7', bg: `url(${boshi})`}
      ],
      industryList: [
        {name: 'A产业', value: 2000, color: '#ffe066'},
        {name: 'B产业', value: 1500, color: '#ffb347'},
        {name: 'C产业', value: 1700, color: '#ff5ca2'},
        {name: 'D产业', value: 900, color: '#b39ddb'},
        {name: 'E产业', value: 500, color: '#4d8aff'},
        {name: 'F产业', value: 1200, color: '#a259ff'},
        {name: 'G产业', value: 700, color: '#3edfa7'},
      ],
      sourceList: [
        // { name: '象山县内', value: 880, color: '#ff5c5c' },
        // { name: '县外市内', value: 72, color: '#4d8aff' },
        // { name: '市外省内', value: 1681, color: '#ffe066' },
        // { name: '浙江省外', value: 11062, color: '#b39ddb' }
      ],
      schoolList: [
        {name: '浙江农业大学', value: 112384, color: '#ff5c5c'},
        {name: '浙江理工大学', value: 336584, color: '#4d8aff'},
        {name: '浙江师范大学', value: 236544, color: '#ffe066'}
      ],
      allSchoolList: [],
      displayCount: 4, // 默认显示4条
      currentSchoolIndex: 0,
      schoolScrollInterval: null,
      schoolColors: [
        '#ff5c5c', // 红色
        '#4d8aff', // 蓝色
        '#ffe066', // 黄色
        '#3edfa7', // 绿色
        '#ff914d', // 橙色
        '#a259ff', // 紫色
        '#ff5ca2'  // 粉色
      ],
      refreshTimer2: null,
      usedColors: new Map(), // 用于记录已使用的颜色
      isModalVisible: false,
    }
  },
  computed: {
    maxSchool() {
      return Math.max(...this.schoolList.map(i => i.value)) * 1.1;
    },
    maxSoure() {
      return Math.max(...this.sourceList.map(i => i.value)) * 1.1;
    },
    displaySourceList() {
      // 直接返回前3条数据，不进行滚动
      return this.sourceList;
    },
  },
  mounted() {
    this.startSchoolScroll();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除resize监听
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
    // 清理图表
    if (this.industryChart) {
      this.industryChart.dispose();
    }
    // 清理定时器
    this.stopSchoolScroll();
    if (this.refreshTimer2) {
      clearInterval(this.refreshTimer2);
      this.refreshTimer2 = null;
    }
  },
  methods: {
    updateCharts() {
      // 清空已使用的颜色记录
      this.usedColors.clear();
      this.graduateData = this.dataObject.children[0]
      this.graduateDataAdd = this.dataObject.children[1]
      this.titleName = this.dataObject.children[6].configName

      this.eduList = this.dataObject.children[2].children.map((item, index) => {
        return {
          name: item.configName,
          value: item.configValue,
          color: this.geteduColor(index),
          bg: this.geteduBg(index)
        }
      })
      this.industryList = this.dataObject.children[3].children.map((item, index) => {
        return {
          name: item.configName,
          value: item.configValue,
          color: this.getindustryColor(index)
        }
      })
      this.schoolList = this.dataObject.children[4].children.map(item => {
        return {
          name: item.configName,
          value: item.configValue,
          color: this.getschoolColor(item.configName)
        }
      })
      this.sourceList = this.dataObject.children[5].children.map((item, index) => {
        return {
          name: item.configName,
          value: item.configValue,
          color: this.getSoucreColor(index)
        }
      })
      //this.schoolList 降序排列，数字小的在前面
      this.schoolList = this.schoolList.sort((a, b) => b.value - a.value);
      // this.sourceList= this.sourceList.sort((a, b) => b.value - a.value);
      this.initIndustryChart();
      this.stopSchoolScroll();
      this.startSchoolScroll();
    },
    getschoolColor(name) {
      // 如果该学校已经有颜色，直接返回
      if (this.usedColors.has(name)) {
        return this.usedColors.get(name);
      }

      // 使用循环方式分配颜色，基于已使用颜色的数量
      const usedCount = this.usedColors.size;
      const colorIndex = usedCount % this.schoolColors.length;
      const selectedColor = this.schoolColors[colorIndex];

      // 记录该学校使用的颜色
      this.usedColors.set(name, selectedColor);

      return selectedColor;
    },
    getSoucreColor(name) {
      if (name === 0) {
        return '#ff5c5c'
      }
      if (name === 1) {
        return '#4d8aff'
      }
      if (name === 2) {
        return '#ffe066'
      }
      if (name === 3) {
        return '#b39ddb'
      }

    },
    getindustryColor(name) {
      if (name === 0) {
        return '#ffe066'
      }
      if (name === 2) {
        return '#ffb347'
      }
      if (name === 3) {
        return '#ff5ca2'
      }
      if (name === 4) {
        return '#b39ddb'
      }
      if (name === 5) {
        return '#4d8aff'
      }
      if (name === 6) {
        return '#a259ff'
      }
      if (name === 7) {
        return '#3edfa7'
      }


    },
    geteduColor(name) {
      if (name === 0) {
        return '#4d8aff'
      }
      if (name === 1) {
        return '#ff914d'
      }
      if (name === 2) {
        return '#3edfa7'
      }
      if (name === 3) {
        return '#569CBC'
      }
    },
    geteduBg(name) {
      if (name === 0) {
        return `url(${zhuanke})`
      }
      if (name === 1) {
        return `url(${benke})`
      }
      if (name === 2) {
        return `url(${shuoshi})`
      }
      if (name === 3) {
        return `url(${boshi})`
      }

    },
    initIndustryChart() {
      if (!this.$refs.industryChart) return
      if (this.industryChart) {
        this.industryChart.dispose();
      }
      const chart = echarts.init(this.$refs.industryChart, null, { renderer: 'svg' });
      this.industryChart = chart;
      chart.setOption({
        grid: {left: 40, right: 20, top: 30, bottom: 30},
        xAxis: {
          type: 'category',
          data: this.industryList.map(i => i.name),
          axisLabel: {color: '#000', fontSize: 13},
          axisLine: {lineStyle: {color: '#A7DDFDFF'}},
          axisTick: {show: false}
        },
        yAxis: {
          type: 'value',
          axisLabel: {color: '#000', fontSize: 13},
          axisLine: {lineStyle: {color: '#A7DDFDFF'}},
          splitLine: {show: true}
        },
        series: [{
          type: 'bar',
          data: this.industryList.map(i => ({value: i.value, itemStyle: {color: i.color}})),
          barWidth: 35,
          label: {
            show: true,
            position: 'top',
            color: '#000',
            fontSize: 12,
            formatter: '{c}人'
          }
        }]
      });
    },
    showAllSchools() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    startSchoolScroll() {
      // 只有当数据超过显示数量时才启动滚动
      if (this.schoolList.length <= this.displayCount) return;

      this.$nextTick(() => {
        const container = this.$refs.schoolListContainer;
        if (!container) return;

        let scrollTop = 0;
        const itemHeight = 40; // 每个项目的高度（30px + 10px margin）
        const totalHeight = this.schoolList.length * itemHeight; // 原始数据的总高度

        this.schoolScrollInterval = setInterval(() => {
          scrollTop += 1; // 每次滚动1px
          // 当滚动到原始数据的一半时，重置到顶部实现无缝循环
          if (scrollTop >= totalHeight) {
            scrollTop = 0;
          }

          container.scrollTop = scrollTop;
        }, 50); // 每50ms滚动一次，实现平滑滚动
      });
    },
    stopSchoolScroll() {
      if (this.schoolScrollInterval) {
        clearInterval(this.schoolScrollInterval);
        this.schoolScrollInterval = null;
      }
    },
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        if (this.industryChart) {
          this.industryChart.resize();
        }
      }, 100);
    }
  }
}
</script>

<style scoped>
.graduate-school-list-container-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.graduate-panel {
  background-image: url('../assets/images/home_right_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.chart-title {
  font-size: 14px;
  padding-left: 10px;
  color: #282828;
  font-weight: bold;
  margin: 12px 0 6px 0;
}

.chart-title2 {
  font-size: 14px;
  padding-left: 10px;
  color: #164166FF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  margin: 5px 0 6px 0;
}

.panel-title {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  margin-bottom: 12px;
  padding-left: 10px;
  background-image: url('../assets/images/icon_home_right.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.graduate-top-cards {
  display: flex;
  gap: 16px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 12px;
}

.graduate-card {
  background: #f0f9ff;
  border-radius: 6px;
  padding: 10px 18px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.graduate-card-title {
  font-size: 13px;
  color: black;
  margin-bottom: 4px;
}

.graduate-card-value {
  font-size: 22px;
  color: black;
}

.graduate-card-rate.up {
  color: #3edfa7;
  font-size: 14px;
  margin-left: 6px;
}

.graduate-edu-cards {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
  margin-left: 10px;
  margin-right: 10px;
}

.edu-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 6px 0;
}

.edu-card-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 2px;
}

.edu-card-label {
  font-size: 13px;
  color: #282828CC;
}

.graduate-bar-title {
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  margin: 12px 0 6px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 14px;
  color: #282828;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chart-title-unit {
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 12px;
  font-weight: normal;
  color: #868686;
}

.industry-chart {
  height: 140px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 10px;
  margin-right: 10px;
  background: #f3faff;
}

.graduate-school-list-container {
  height: 160px;
  width: 50%;
  overflow: hidden;
  position: relative;
}

.graduate-school-list {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.graduate-school-list::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.graduate-school-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  height: 30px; /* 固定每个项目的高度 */
  opacity: 1;
  transition: opacity 0.3s ease;
}

.graduate-school-item:hover {
  opacity: 0.8;
}

.school-label {
  margin-left: 10px;
  margin-bottom: 2px;
  font-size: 12px;
  line-height: normal;
  letter-spacing: 0em;
  color: black;
}

.school-bar-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: calc(100% - 20px); /* 减去左右padding的宽度 */
  margin: 0 10px; /* 使用margin代替padding */
}

.school-bar-bg {
  flex: 1;
  min-width: 0;
  height: 12px;
  background: #f5f5f5;
  border-radius: 6px;
  overflow: hidden;
}

.school-bar-fg {
  height: 100%;
  border-radius: 6px;
  transition: width 0.3s ease;
}

.school-value {
  flex-shrink: 0;
  font-size: 13px;
  color: black;
  text-align: right;
  white-space: nowrap;
}

.graduate-card-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.graduate-card-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.more-schools {
  float: right;
  color: #4d8aff;
  cursor: pointer;
  font-size: 13px;
  font-weight: normal;
  margin-right: 10px;
}

.more-schools:hover {
  text-decoration: underline;
}

.school-modal {
  position: fixed;
  inset: 0;
  z-index: 300000;
  box-sizing: border-box;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  width: min(980px, 92vw);
  height: 70vh;
  max-height: 70vh;
  min-height: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.22);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e9eef7;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
  color: #1f2d3d;
}

.school-modal .close-btn {
  font-size: 24px;
  line-height: 1;
  color: #909399;
  cursor: pointer;
}

.school-modal .close-btn:hover {
  color: #409eff;
}

.modal-body {
  flex: 1;
  min-height: 0;
  padding: 12px 10px 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-body .school-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 4px 0 2px;
}

.modal-body .school-item {
  padding: 6px 6px 8px;
}

.modal-body .school-label {
  margin-left: 0;
  font-size: 12px;
  color: #282828;
  font-weight: normal;
}

.modal-body .school-bar-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.modal-body .school-bar-bg {
  flex: 1;
  width: auto;
  height: 8px;
  background: #e0e6f6;
  border-radius: 6px;
  overflow: hidden;
  margin-right: 12px;
  margin-left: 0;
}

.modal-body .school-bar-fg {
  height: 100%;
  border-radius: 6px;
  transition: width 0.4s;
}

.modal-body .school-value {
  min-width: 70px;
  margin-left: 0;
  font-size: 12px;
  color: #282828CC;
  font-weight: bold;
  text-align: left;
}


</style>
